export const FINTELLIGENCE_PERISCOPE = "FintelligenceSMARTUIPeriscope";
